var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"without-data"},[_c('img',{staticClass:"without-data__img",attrs:{"src":_vm.imgSrc,"alt":"无数据"}}),_c('p',{staticClass:"without-data__text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }